import React, { ReactNode, useEffect } from "react";
import { Box, Flex, Tabs, Text, Button } from "@radix-ui/themes";

import { composeProviders } from "shared/utils/compose-providers";

import { PersonalInfo } from "./personal-info";
import { ContactInfo } from "./contact-info";
import { DesiredPosition } from "./desired-position";
import { WorkExperience, WorkExperienceProvider } from "./work-experience";
import { EducationInfo, EducationInfoProvider } from "./education-info";
import { AdditionalInfo, AdditionalInfoProvider } from "./additonal-info";

import { CreateResumeProvider } from "./create-resume.context";

import "./feature-create-resume.css";
import { IconEast } from "shared/icons";

const Providers = composeProviders([
  WorkExperienceProvider,
  EducationInfoProvider,
  AdditionalInfoProvider,
  CreateResumeProvider,
]);

const CreateResumeTab = {
  PERSONAL_INFO: "PersonalInfo",
  CONTACT_INFO: "ContactInfo",
  DESIRED_POSITION: "DesiredPosition",
  WORK_EXPERIENCE: "WorkExperience",
  EDUCATION_INFO: "EducationInfo",
  ADDITIONAL_INFO: "AdditionalInfo",
} as const;
type CreateResumeTab = (typeof CreateResumeTab)[keyof typeof CreateResumeTab];

export const FeatureCreateResume = () => {
  const [step, setStep] = React.useState<CreateResumeTab>(
    CreateResumeTab.DESIRED_POSITION
  );
  return (
    <Providers>
      <Flex className="create-resume" width="100%" direction="column">
        <Tabs.Root
          value={step}
          onValueChange={(value) => setStep(value as CreateResumeTab)}
          className="create-resume__tabs"
        >
          <Tabs.List
            wrap="wrap"
            justify="center"
            className="create-resume__tab-list"
            size="2"
          >
            <Tabs.Trigger
              className="create-resume__tab-trigger"
              value={CreateResumeTab.PERSONAL_INFO}
            >
              Особиста інформація
            </Tabs.Trigger>
            <Tabs.Trigger
              className="create-resume__tab-trigger"
              value={CreateResumeTab.CONTACT_INFO}
            >
              Контактна інформація
            </Tabs.Trigger>
            <Tabs.Trigger
              className="create-resume__tab-trigger"
              value={CreateResumeTab.DESIRED_POSITION}
            >
              Бажана посада
            </Tabs.Trigger>
            <Tabs.Trigger
              className="create-resume__tab-trigger"
              value={CreateResumeTab.WORK_EXPERIENCE}
            >
              Досвід роботи
            </Tabs.Trigger>
            <Tabs.Trigger
              className="create-resume__tab-trigger"
              value={CreateResumeTab.EDUCATION_INFO}
            >
              Інформація про освіту
            </Tabs.Trigger>
            <Tabs.Trigger
              className="create-resume__tab-trigger"
              value={CreateResumeTab.ADDITIONAL_INFO}
            >
              Додаткова інформація
            </Tabs.Trigger>
          </Tabs.List>

          <Box pt="3">
            <Tabs.Content value={CreateResumeTab.PERSONAL_INFO}>
              <PersonalInfo
                renderSteps={(valid: boolean) => {
                  return (
                    <Flex>
                      <Button
                        disabled={!valid}
                        onClick={() => {
                          setStep(CreateResumeTab.CONTACT_INFO);
                        }}
                        type="button"
                      >
                        Наступний крок <IconEast />
                      </Button>
                    </Flex>
                  );
                }}
              />
            </Tabs.Content>

            <Tabs.Content value={CreateResumeTab.CONTACT_INFO}>
              <ContactInfo
                renderSteps={(valid: boolean) => {
                  return (
                    <Flex>
                      <Button
                        disabled={!valid}
                        onClick={() => {
                          setStep(CreateResumeTab.CONTACT_INFO);
                        }}
                        type="button"
                      >
                        Наступний крок <IconEast />
                      </Button>
                    </Flex>
                  );
                }}
              />
            </Tabs.Content>

            <Tabs.Content value={CreateResumeTab.DESIRED_POSITION}>
              <DesiredPosition />
            </Tabs.Content>

            <Tabs.Content value={CreateResumeTab.WORK_EXPERIENCE}>
              <WorkExperience />
            </Tabs.Content>

            <Tabs.Content value={CreateResumeTab.EDUCATION_INFO}>
              <EducationInfo />
            </Tabs.Content>

            <Tabs.Content value={CreateResumeTab.ADDITIONAL_INFO}>
              <AdditionalInfo />
            </Tabs.Content>
          </Box>
        </Tabs.Root>
      </Flex>
    </Providers>
  );
};
